import { SubscriptionTiers } from "@next-platform/client-common-core";

/**
 * Get the badge color classes for a subscription tier
 * @param tier - The subscription tier
 * @returns The color classes for the badge
 */
export function getTierBadgeColors(tier: SubscriptionTiers): string {
  const badgeColors = {
    [SubscriptionTiers.MINIMAL]: "bg-blue-1 text-blue-10 border-none",
    [SubscriptionTiers.BASIC]: "bg-purple-2 text-purple-9 border-none",
    [SubscriptionTiers.PREMIUM]: "bg-yellow-2 text-yellow-9 border-none",
  };

  return badgeColors[tier as keyof typeof badgeColors] || "";
}
